import React, { Component } from 'react'

class SpecItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: {
                zh: "產品規格",
                en: "Specifications",
                ja: "製品仕様"
            }
        }
    }

    render() {
        return (
            <div className="spec_holder">
                <h2 className="spec_category">{this.state.title[this.props.lang]}</h2>
                <div className="spec_item_container">
                    <div className="spec_img_container">
                        <img src={this.props.img} alt="spec" className="spec_img" />
                    </div>
                    <div className="spec_table_wrap">
                        {this.props.title.map((item, index) => (
                            <div key={"specrow" + index} className="spec_row">
                                <div className="spec_title">{item[this.props.lang]}</div>
                                <div className="spec_content">
                                    {this.props.content[index][this.props.lang].join(' / ')}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default SpecItem;
